var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.923077 12H3.23077V11.0769H1.43077L4.61538 8.30769L4.15385 7.38462L0.923077 10.2V8.76923H0V11.0769C0.000730515 11.3215 0.0982161 11.5559 0.271169 11.7288C0.444121 11.9018 0.678486 11.9993 0.923077 12ZM0.923077 1.8L4.15385 4.61538L4.61538 3.69231L1.43077 0.923077H3.23077V0H0.923077C0.678486 0.000730489 0.444121 0.0982198 0.271169 0.271172C0.0982161 0.444125 0.000730515 0.678486 0 0.923077V3.23077H0.923077V1.8ZM8.76923 11.0769V12H11.0769C11.3215 11.9993 11.5559 11.9018 11.7288 11.7288C11.9018 11.5559 11.9993 11.3215 12 11.0769V8.76923H11.0769V10.2L7.84615 7.38462L7.38462 8.30769L10.5692 11.0769H8.76923ZM7.84615 4.61538L11.0769 1.8V3.23077H12V0.923077C11.9993 0.678486 11.9018 0.444125 11.7288 0.271172C11.5559 0.0982198 11.3215 0.000730489 11.0769 0H8.76923V0.923077H10.5692L7.38462 3.69231L7.84615 4.61538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseSize);
export default __webpack_public_path__ + "static/media/increase_size.0ff567d6.svg";
export { ForwardRef as ReactComponent };